var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "212px",
    height: "154px",
    viewBox: "0 0 212 154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "browser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-8---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.3--Agreement-popup---shape",
    transform: "translate(-632.000000, -864.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "browser",
    transform: "translate(632.000000, 864.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 211,
    height: 153,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DFE4EE",
    x: 0,
    y: 0,
    width: 212,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    x: 0.5,
    y: 0.5,
    width: 211,
    height: 153,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "redo",
    transform: "translate(21.000000, 7.000000)",
    fill: "#969696",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.80000953,1.80021286 C3.68955784,1.80021286 3.60001905,1.88975099 3.60001905,2.00020187 C3.60493095,2.77290358 3.06015127,3.44011185 2.30207271,3.5898363 C1.54399415,3.73956074 0.786458268,3.32956654 0.497231307,2.61301852 C0.208004346,1.8964705 0.468672497,1.07549515 1.11827736,0.657031547 C1.76788223,0.238567947 2.62318091,0.340657837 3.1560402,0.90026235 L2.67606307,0.90026235 C2.56561138,0.90026235 2.4760726,0.989800477 2.4760726,1.10025135 C2.4760726,1.21070223 2.56561138,1.30024036 2.67606307,1.30024036 L3.58201991,1.30024036 C3.6924716,1.30024036 3.78201038,1.21070223 3.78201038,1.10025135 L3.78201038,0.200300841 C3.78201038,0.0898499642 3.6924716,0.000311837738 3.58201991,0.000311837738 C3.47156822,0.000311837738 3.38202944,0.0898499642 3.38202944,0.200300841 L3.38202944,0.554281376 C2.69543083,-0.102055368 1.64189084,-0.184908992 0.86113337,0.356030358 C0.0803759046,0.896969708 -0.2121822,1.91245281 0.161104344,2.78586443 C0.534390889,3.65927604 1.47052953,4.14963535 2.40108406,3.95918947 C3.33163859,3.76874359 3.99986205,2.95003797 4,2.00020187 C4,1.94716148 3.97892964,1.8962935 3.94142415,1.85878829 C3.90391866,1.82128307 3.8530503,1.80021286 3.80000953,1.80021286 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 29,
    y: 7,
    width: 171,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-ul",
    transform: "translate(202.000000, 8.000000)",
    fill: "#969696",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.51306381,2.57245014 C0.484533029,2.54969042 0.450889929,2.53184952 0.414064962,2.51995116 C0.341027404,2.49494714 0.25910517,2.49494714 0.186067613,2.51995116 C0.149242646,2.53184952 0.115599545,2.54969042 0.0870687643,2.57245014 C0.0597568931,2.59622561 0.0383476474,2.62426131 0.024069497,2.65494854 C-0.0229089757,2.74804601 0.0019463856,2.85555448 0.0870687643,2.92744326 C0.116228707,2.94952556 0.149712568,2.96728202 0.186067613,2.97994224 C0.258678733,3.00668592 0.341453842,3.00668592 0.414064962,2.97994224 C0.450420007,2.96728202 0.483903867,2.94952556 0.51306381,2.92744326 C0.598186189,2.85555448 0.62304155,2.74804601 0.576063078,2.65494854 C0.561784927,2.62426131 0.540375681,2.59622561 0.51306381,2.57245014 Z M1.50005233,0.499990309 L5.70000349,0.499990309 C5.86568699,0.499990309 6,0.388063666 6,0.249995154 C6,0.111926643 5.86568699,0 5.70000349,0 L1.50005233,0 C1.33436883,0 1.20005582,0.111926643 1.20005582,0.249995154 C1.20005582,0.388063666 1.33436883,0.499990309 1.50005233,0.499990309 Z M0.51306381,1.32247437 C0.426796604,1.2515396 0.297785442,1.23082696 0.186067613,1.26997538 C0.149712568,1.28263561 0.116228707,1.30039206 0.0870687643,1.32247437 C0.0597568931,1.34624983 0.0383476474,1.37428553 0.024069497,1.40497277 C-0.00802316565,1.46548157 -0.00802316565,1.53446029 0.024069497,1.59496909 C0.0392618806,1.62526472 0.0605697918,1.65316772 0.0870687643,1.67746749 C0.116228707,1.69954979 0.149712568,1.71730625 0.186067613,1.72996647 C0.258678733,1.75671015 0.341453842,1.75671015 0.414064962,1.72996647 C0.450420007,1.71730625 0.483903867,1.69954979 0.51306381,1.67746749 C0.539562783,1.65316772 0.560870694,1.62526472 0.576063078,1.59496909 C0.60815574,1.53446029 0.60815574,1.46548157 0.576063078,1.40497277 C0.561784927,1.37428553 0.540375681,1.34624983 0.51306381,1.32247437 Z M5.70000349,1.24997577 L1.50005233,1.24997577 C1.33436883,1.24997577 1.20005582,1.36190242 1.20005582,1.49997093 C1.20005582,1.63803944 1.33436883,1.74996608 1.50005233,1.74996608 L5.70000349,1.74996608 C5.86568699,1.74996608 6,1.63803944 6,1.49997093 C6,1.36190242 5.86568699,1.24997577 5.70000349,1.24997577 Z M0.51306381,0.0724985948 C0.484533029,0.0497388786 0.450889929,0.0318979788 0.414064962,0.0199996124 C0.302347132,-0.0191488114 0.173335971,0.00156382915 0.0870687643,0.0724985948 C0.0605697918,0.0967983591 0.0392618806,0.12470136 0.024069497,0.154996996 C-0.00802316565,0.215505793 -0.00802316565,0.284484516 0.024069497,0.344993313 C0.0392618806,0.375288949 0.0605697918,0.40319195 0.0870687643,0.427491714 C0.116228707,0.44957402 0.149712568,0.467330475 0.186067613,0.479990697 C0.297785442,0.51913912 0.426796604,0.49842648 0.51306381,0.427491714 C0.539562783,0.40319195 0.560870694,0.375288949 0.576063078,0.344993313 C0.60815574,0.284484516 0.60815574,0.215505793 0.576063078,0.154996996 C0.560870694,0.12470136 0.539562783,0.0967983591 0.51306381,0.0724985948 Z M5.70000349,2.49995154 L1.50005233,2.49995154 C1.33436883,2.49995154 1.20005582,2.61187819 1.20005582,2.7499467 C1.20005582,2.88801521 1.33436883,2.99994185 1.50005233,2.99994185 L5.70000349,2.99994185 C5.86568699,2.99994185 6,2.88801521 6,2.7499467 C6,2.61187819 5.86568699,2.49995154 5.70000349,2.49995154 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(3.000000, 7.000000)",
    fill: "#969696",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9761221,1.87315748 C13.9609722,1.83227414 13.9382557,1.79492334 13.9092762,1.76324827 L12.3177057,0.0979572469 C12.2369626,0.0134741795 12.119277,-0.0195202142 12.0089799,0.0114027347 C11.8986828,0.0423256835 11.8125309,0.132468043 11.7829769,0.24787406 C11.7534229,0.363280076 11.7849566,0.48641683 11.8656997,0.570899897 L12.9161362,1.66666139 L10.5001323,1.66666139 C10.3243323,1.66666139 10.1818182,1.81577663 10.1818182,1.99971959 C10.1818182,2.18366256 10.3243323,2.3327778 10.5001323,2.3327778 L12.9161362,2.3327778 L11.8656997,3.42853929 C11.8054388,3.4910765 11.7715429,3.5762048 11.7715429,3.66501062 C11.7715429,3.75381644 11.8054388,3.83894473 11.8656997,3.90148194 C11.9254685,3.96453407 12.0068282,4 12.0917027,4 C12.1765772,4 12.257937,3.96453407 12.3177057,3.90148194 L13.9092762,2.23619092 C13.9382557,2.20451585 13.9609722,2.16716505 13.9761221,2.12628171 C14.0079593,2.04519491 14.0079593,1.95424428 13.9761221,1.87315748 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79430396,1.87315748 C3.779154,1.83227414 3.75643752,1.79492334 3.727458,1.76324827 L2.13588755,0.0979572469 C2.05514445,0.0134741795 1.93745882,-0.0195202142 1.8271617,0.0114027347 C1.71686458,0.0423256835 1.63071272,0.132468043 1.6011587,0.24787406 C1.57160467,0.363280076 1.60313844,0.48641683 1.68388154,0.570899897 L2.73431804,1.66666139 L0.318314091,1.66666139 C0.142514073,1.66666139 0,1.81577663 0,1.99971959 C0,2.18366256 0.142514073,2.3327778 0.318314091,2.3327778 L2.73431804,2.3327778 L1.68388154,3.42853929 C1.62362065,3.4910765 1.58972476,3.5762048 1.58972476,3.66501062 C1.58972476,3.75381644 1.62362065,3.83894473 1.68388154,3.90148194 C1.74365029,3.96453407 1.82501006,4 1.90988454,4 C1.99475903,4 2.07611879,3.96453407 2.13588755,3.90148194 L3.727458,2.23619092 C3.75643752,2.20451585 3.779154,2.16716505 3.79430396,2.12628171 C3.8261411,2.04519491 3.8261411,1.95424428 3.79430396,1.87315748 Z",
    id: "Path",
    transform: "translate(1.909091, 2.000000) scale(-1, 1) translate(-1.909091, -2.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 2.000000)",
    fill: "#969696"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.41891892,
    cy: 1.5,
    rx: 1.41891892,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.5,
    cy: 1.5,
    rx: 1.41891892,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.5810811,
    cy: 1.5,
    rx: 1.41891892,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,15 L212,15",
    id: "Path-2",
    stroke: "#969696"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopup4);
export default __webpack_public_path__ + "static/media/Popup4.a4075d4d9af4403b3a8da85dfd22f4ee.svg";
export { ForwardRef as ReactComponent };